module.exports = __webpack_public_path__ + "static/img/1.1a6a2465.png";